import { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AuthRoutePath from "./AuthRoutePath";
import PublicRoutePath from "./PublicRoutePath";
import Loader from "../core-component/ui/Loader";
import { restoreSessionToken } from "../services/auth/SessionTokenServices";
import { handleError } from "../utils/AppFunctions";

const AppRouter: React.FC = () => {
  const [isSessionChecked, setIsSessionChecked] = useState(false);

  useEffect(() => {
    restoreSessionToken()
      .catch((e) => handleError(e, "restoreSessionToken"))
      .finally(() => setIsSessionChecked(true));
  }, []);

  if (!isSessionChecked) return <Loader />;

  return (
    <Router>
      <AuthRoutePath />
      <PublicRoutePath />
    </Router>
  );
};

export default AppRouter;
